import React, { useState } from 'react'
import { IconButton, MenuItem, Typography } from '@mui/material'

import ChipMenuDialog from '../../../../components/ChipMenuDialog/ChipMenuDialog'
import MaterialSymbol from '../../../../components/MaterialSymbol'
import { QuoteDeclineModal } from './QuoteDeclineModal'
import { Quote } from '../../storage/types'

export const MenuEntry = ({ label, onClick }: { label: string; onClick: () => void }) => (
  <MenuItem onClick={onClick}>
    <Typography variant='body2'>{label}</Typography>
  </MenuItem>
)

interface QuoteMoreOptionsProps {
  quote: Quote | null
}

export const QuoteMoreOptions: React.FC<QuoteMoreOptionsProps> = ({ quote }) => {
  // console.log(quote)
  const [open, setOpen] = useState(false)
  const [declineModalOpen, setDeclineModalOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    setOpen((prev) => !prev)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setOpen(false)
  }

  const decline = () => {
    setOpen(false)
    setDeclineModalOpen(true)
  }
  const cancel = () => {
    setOpen(false)
  }

  return (
    <>
      <IconButton
        aria-label='Seed Mix Menu'
        color='primary'
        onClick={handleClick}
        sx={{ p: 0, fontSize: '16px', fontWeight: 'bold' }}
      >
        More options
        <MaterialSymbol>more_vert</MaterialSymbol>
      </IconButton>
      <ChipMenuDialog
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        paperSx={{ padding: 0 }}
      >
        <MenuEntry onClick={decline} label='Decline' />
        <MenuEntry onClick={cancel} label='Cancel' />
      </ChipMenuDialog>
      <QuoteDeclineModal
        quote={quote}
        open={declineModalOpen}
        handleClose={() => setDeclineModalOpen(false)}
      />
    </>
  )
}
